import {
  AfterContentChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Optional,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Item } from '../../entity/entities';
import { GSBaseControl } from '../gs.base.control';
import { FormLocationMultiselectWithExpirationProperty } from '../../entity/form/formLocationMultiselectWithExpiration.property';
import { MultiSelect } from 'primeng/multiselect';

@Component({
  selector: 'app-location-multiselect-with-expiration',
  templateUrl: './gs.location-multiselect-expiration.component.html',
  styleUrls: ['./gs.location-multiselect-expiration.component.css'],
})
export class GsLocationMultiselectWithExpirationComponent
  extends GSBaseControl
  implements OnInit, OnDestroy, AfterContentChecked, AfterViewInit {

  //#region -------Properties

  get options() {
    return this.property.options;
  }

  isOptionSelected(opt): boolean {
    return this.value?.some(v => v.clientCode === opt.value.clientCode);
  }

  isCalendarDisabled(opt: any): boolean {
    return !this.value?.some(
      v => v.clientCode === opt.value.clientCode
    );
  }

  @ViewChildren('selectOption') selectOption: QueryList<ElementRef>;
  optionHandled = false;
  _selectAll;
  panelHeight: string;
  scrollItemHight: number = 87;
  private destroy$ = new Subject<void>();

  @ViewChild('multiLocationSelect') multiLocationSelect: MultiSelect;
  private isCalendarOpen = false;
  private originalHideMethod: any;
  private hideBlocked = false;
  //#endregion


  //#region -------Constructor
  constructor(
    @Optional() prop: FormLocationMultiselectWithExpirationProperty,
    @Optional() item: Item,
    private changeDr: ChangeDetectorRef
  ) {
    super(changeDr);
    this.property = prop;
    this.item = item;
  }
  //#endregion

  //#region -------NG Events
  ngOnInit() {
    (this.property as FormLocationMultiselectWithExpirationProperty).optionsSet
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updatePanelHeight();
        this.mergeDbValuesIntoOptions();
      });

    if ((this.property as FormLocationMultiselectWithExpirationProperty).options) {
      this.updatePanelHeight();
      //this.mergeDbValuesIntoOptions();
    }
  }

  // ngAfterViewInit() {
  //   // Override the hide method to prevent closing when calendar is open
  //   if (this.multiLocationSelect) {
  //     this.originalHideMethod = this.multiLocationSelect.hide.bind(this.multiLocationSelect);

  //     this.multiLocationSelect.hide = () => {  //
  //       if (!this.hideBlocked) {
  //         this.originalHideMethod();
  //       }
  //     };
  //   }
  // }


ngAfterViewInit() {
  setTimeout(() => {
    this.patchCalendarOverlay();
  }, 0);
}

private patchCalendarOverlay() {
  // Every calendar inside the multiselect item
  const calendars = document.querySelectorAll('.p-datepicker');

  calendars.forEach((panel) => {
    panel.addEventListener('mousedown', (e) => e.stopPropagation());
    panel.addEventListener('click', (e) => e.stopPropagation());
  });
}

  ngAfterContentChecked() {
    if (this.selectOption && this.selectOption.toArray().length) {
      if (!this.optionHandled) {
        this.selectOption.toArray()
          .filter(e => e.nativeElement.children[0].classList.contains("disabled_opacity-no-color"))
          .forEach(e => {
            e.nativeElement.parentElement.classList.add("no-event");
            e.nativeElement.parentElement.children[0].classList.add("disabled_opacity-no-color");
          });
        this.optionHandled = true;
      }
    } else {
      this.optionHandled = false;
    }
  }

  ngOnDestroy() {
    // Restore original hide method
    if (this.multiLocationSelect && this.originalHideMethod) {
      this.multiLocationSelect.hide = this.originalHideMethod;
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  updatePanelHeight(): void {
    const optionCount = this.options ? this.options.length : 0;
    const visibleItems = optionCount > 0 ? Math.min(optionCount, 4) : 0;
    this.panelHeight = `${this.scrollItemHight * visibleItems}px`;
  }

  selectedClients: ClientSelection[] = [];

  isSelected(opt: ClientSelection): boolean {
    return this.selectedClients.some(c => c.clientCode === opt.clientCode);
  }

  onSelect(event: any) {
    // Date selected - wait a bit before allowing hide
    setTimeout(() => {
      this.hideBlocked = false;
      this.isCalendarOpen = false;
    }, 200);
  }

  toDateInputValue(opt: ClientSelection): string {
    let date = opt.expiresAt;
    if (!opt.expiresAt) {
      const index = this.value.findIndex(s => s.clientCode === opt.clientCode);
      if (index > -1) {
        date = this.value[index].expiresAt ? new Date(this.value[index].expiresAt) : null;
      }
    }
    if (!date) return '';

    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  }

  //#endregion

  //#region -------UI Events

  dateUpdated(event: any) {
  console.log(event);
  }

  change(e) {
    if (e) {
      if (!e.itemValue)
        this._selectAll = !this._selectAll;
      let previousValue = this.data[this.name];
      this.value = e.value;
      this.item.reCheckDirty();
      this.onChange.emit({
        propertyName: this.name,
        previousValue: previousValue,
        newValue: this.value,
        event: e,
        item: this.item,
        property: this.property
      });
      this.property.changed.emit({
        propertyName: this.name,
        previousValue: previousValue,
        newValue: this.value,
        event: e,
        item: this.item,
        property: this.property
      });
    }
  }

onCalendarShow() {
  setTimeout(() => {
    const calendarPanel = document.querySelector('.p-datepicker');
    if (calendarPanel) {
      calendarPanel.addEventListener('mousedown', e => e.stopPropagation());
      calendarPanel.addEventListener('click', e => e.stopPropagation());
    }
  });
}

  onCalendarClose(event: any) {
    // Delay to allow any pending interactions
    setTimeout(() => {
      this.hideBlocked = false;
      this.isCalendarOpen = false;
    }, 150);
  }

  onMultiSelectPanelShow() {
  }

  onMultiSelectPanelHide() {
  }

  onCalendarWrapperClick(event: MouseEvent) {
    // Stop propagation to prevent multiselect item toggle
    event.stopPropagation();
  }

  private mergeDbValuesIntoOptions() {
  if(!this.options || this.options.length === 0 ) return;
  if (!this.value || this.value?.length === 0) return;

  const mergedSelectedValues = [];

  for (const sel of this.value) {
    const opt = this.options.find(o => o.value.clientCode === sel.clientCode);
    if (!opt) continue;

    // Always override option.expiresAt with DB value
    if (sel.expiresAt === null) {
      opt.value.expiresAt = null;
    } else {
      opt.value.expiresAt = new Date(sel.expiresAt);
    }
    mergedSelectedValues.push(opt.value);
  }

  this.value = mergedSelectedValues;
  this.changeDr.detectChanges();
}


  //#endregion

  //#region -------Private
  //#endregion
}

export interface ClientSelection {
  clientCode: number;
  expiresAt?: Date | null;
}
